module.exports = __webpack_public_path__ + "img/メルセデス・ベンツ.b5530cca.png";